import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { ProjectService } from '../../../../services/ProjectService';
import { toast } from 'react-toastify';
import { IoIosFolder } from 'react-icons/io';
import { FaCheck, FaRegEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";

export default function AdminSubFolder() {
  const { id,mainFolderId } = useParams();
  const navigate = useNavigate();
  const [folders, setFolders] = useState([]);
  const [subFolderDetails, setFolderDetails] = useState("");

  const [editingFolderId, setEditingFolderId] = useState(null);
  const [editName, setEditName] = useState("");

  useEffect(() => {
      const fetchFolders = async () => {
        try {
          const result = await ProjectService.getProjectSubFolders(id,mainFolderId);
          if (result) {
            setFolders(result);
            // console.log("Subfolders ",result);           
          }
        } catch (error) {
          toast.error(error?.message);
        }
      };
      fetchFolders();
  }, [id,mainFolderId]);

  const startEdit = (folder) => {
    setEditingFolderId(folder.id);
    setEditName(folder.name);
  };

  const cancelEdit = () => {
    setEditingFolderId(null);
    setEditName("");
  };

  useEffect(() => {
      const fetchMainFolderDetail = async () => {
        try {
          const result = await ProjectService.getProjectAndMainFolderByMainFolderId(mainFolderId);
          if (result) {
            setFolderDetails(result);
            // console.log("main folder ",result);           
          }
        } catch (error) {
          toast.error(error?.message);
        }
      };
      fetchMainFolderDetail();
  }, [mainFolderId]);

  const saveEdit = async (folderId) => {
      if (!editName.trim()) {
        toast.error("Folder name cannot be empty");
        return;
      }
      try {
        const finalData = {
          projectId: id,
          name: editName,
        };
        const result = await ProjectService.editSubProjectFolder(finalData,editingFolderId);
        if (result) {
          setFolders((prev) =>
            prev.map((f) =>
              f.id === folderId ? { ...f, name: editName } : f
            )
          );
          toast.success("Folder name updated");
          cancelEdit();
        }else{
          toast.error("Failed to update folder name");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to update folder name");
      }
  };

  return (
    <div className="p-6">
      <div
      onClick={()=>navigate(-1)} 
      className="pb-6">
        <p className='capitalize hover:underline hover:text-blue-500 text-base lg:text-lg font-semibold'>
          {subFolderDetails.projectName} {">"} {subFolderDetails.mainFolderName} 
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5 bg-white p-8">
        {folders.map((folder) => (
          <div
            key={folder.id}
            onClick={() => navigate(`/view-project/emp-doc/documents/${id}/${mainFolderId}/${folder.id}`)}
            className="border rounded-lg p-3 hover:shadow-md cursor-pointer"
          >
            <div className="flex flex-col items-center gap-3">
              <div className="h-24 w-24">
                <IoIosFolder className="w-full h-full text-[#F4B400]" />
              </div>
              <div className="w-full text-center">
              {editingFolderId === folder.id ? (
                <div className="flex items-center gap-2 justify-center">
                  <input
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    className="border px-2 py-1 text-sm rounded w-32"
                    autoFocus
                    onClick={(e) => e.stopPropagation()}
                  />
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      saveEdit(folder.id);
                    }}
                    className="text-green-600 text-sm"
                  >
                    <FaCheck className="text-md lg:text-lg" />
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      cancelEdit();
                    }}
                    className="text-red-600 text-sm"
                  >
                    <ImCross className="text-sm lg:text-md"/>
                  </button>
                </div>
                ) : (
                <div className="flex items-center justify-center gap-4">
                  <span className="break-words line-clamp-2">
                    {folder.name}
                  </span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      startEdit(folder);
                    }}
                    className="text-blue-500 hover:text-blue-700 text-sm md:text-md lg:text-lg xl:text-xl"
                  >
                    <FaRegEdit />
                  </button>
                </div>
                )}
              </div>
            </div>
          </div>
        ))}

        {folders.length === 0 && (
          <p className="col-span-full text-center text-gray-500">
            No folders found
          </p>
        )}
      </div>
    </div>
  )
}
